module.exports = __webpack_public_path__ + "media/images/placeholders/video-player-with-play-d4af42d6e8c4953ac5deb937c99bcb7f.svg";